import { ObjectText } from '../../types/ObjectTypes';

export const getTextByMarkType = (texts: ObjectText[], markType: string): string => {
  const text = texts.find(text => {
    return text.MarkType === markType;
  });

  if (text && text.Content !== '<p></p>\n' && text.Content !== '<p></p>') {
    return text.Content;
  } else {
    return '';
  }
};
